import React from "react";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import TasksAllocations from "./TasksAllocations";
import WorkStatus from "./WorkStatus";
import Pagenotfound from "../../components/common/Pagenotfound";
import { useSelector } from "react-redux";

function TaskAllocation() {
  const location = useLocation();
  const isActiveTab = (path) => location.pathname.includes(path);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { role: login_user_role } = login_user;
  // console.log("::::::::", isActiveTab);

  return (
    <div className="bg-white p-3 detailpage">
      {/* Nav Tabs */}
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <Link
            to="WorkStatus"
            className={`nav-link ${isActiveTab("WorkStatus") ? "active" : ""}`}
          >
            Work Status
          </Link>
        </li>
        {(login_user_role === "ADMIN" || login_user_role === "MANAGER") && (
          <li className="nav-item pe-4" role="presentation">
            <Link
              to="Task-Allocations"
              className={`nav-link ${
                isActiveTab("Task-Allocations") ? "active" : ""
              }`}
            >
              Tasks Allocations
            </Link>
          </li>
        )}
      </ul>

      {/* Tab Content */}
      <div className="tab-content" id="myTabContent">
        <Routes>
          <Route index element={<Navigate to="WorkStatus" replace />} />
          <Route path="WorkStatus" element={<WorkStatus />} />
          {(login_user_role === "ADMIN" || login_user_role === "MANAGER") && (
            <Route path="Task-Allocations" element={<TasksAllocations />} />
          )}
          <Route path="*" element={<Pagenotfound />} />
        </Routes>
      </div>
    </div>
  );
}

export default TaskAllocation;
